export const url: string = 'https://server.atab.org.bd';

//export const url: string = 'http://10.10.220.45:5000'; //srabon
//export const url: string = 'http://10.10.220.46:5000'; //masud

export const imgUrl: string =
  'https://m360ict.s3.ap-south-1.amazonaws.com/uploads';

//======== Auth context helper ========//
export const SET_SIGNUP_DATA = 'SET_SIGNUP_DATA';
export const AUTH_USER_SUCCESS = 'AUTH_USER_SUCCESS';
export const AUTH_USER_FAILED = 'AUTH_USER_FAILED';
export const UPDATE_AUTH_USER_INFO = 'UPDATE_AUTH_USER_INFO';
// notification
export const NEW_NOTIFICATION = 'NEW_NOTIFICATION';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
export const FETCH_NOTIFICATION = 'FETCH_NOTIFICATION';

// message
export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_NEW_MESSAGE = 'SET_NEW_MESSAGE';

export const debounceTime = 2000;
// Srabon123456@  master password
